<template lang="pug">
page-template.px-lg-15.mb-10(title="Contato", fluid)
  grid-container(cols="auto", cols-md="auto auto", gap="40px")
    grid-item(row-end="2")
      v-tabs.section-tabs(color="white")
        v-tab.font-weight-bold(active-class="primary rounded-t") Fale Conosco
        v-tab.font-weight-bold(active-class="primary rounded-t") Trabalhe Conosco
        v-tab-item
          section.mt-4
            contact-us(:action="server + '/rest/email/contact-us'")
        v-tab-item
          section.mt-4
            work-with-us(:action="server + '/rest/email/work-with-us'")
    section
      .text-h5.mb-3.font-weight-bold INFORMAÇÕES
      div(v-if="informations.local")
        v-btn.text-none(:href="informations.local_link", target="_blank", icon)
          v-icon(small) fas fa-map-marked-alt
        span.barlow Local: {{ informations.local }}
      div(v-if="informations.operation")
        v-btn.text-none(target="_blank", icon)
          v-icon(small) fas fa-clock
        span.barlow Horas: {{ informations.operation }}
      div(v-if="informations.tel")
        v-btn.text-none(
          :href="getTelLinkFromPhone(informations.tel)",
          target="_blank",
          icon
        )
          v-icon(small) fas fa-phone
        span.barlow Telefone: {{ informations.tel }}
      div(v-if="informations.email")
        v-btn.text-none(
          :href="'mailto:' + informations.email",
          target="_blank",
          icon
        )
          v-icon(small) fas fa-envelope
        span.barlow E-mail: {{ informations.email }}
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import ContactUs from "@/components/forms/ContactUs";
import WorkWithUs from "@/components/forms/WorkWithUs";
import { getTelLinkFromPhone } from "@/components/utils.js";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  components: {
    PageTemplate,
    ContactUs,
    WorkWithUs,
  },
};
</script>
